import React from "react";
import {
  ActivityIndicator,
  FlatList,
  type ListRenderItem,
  RefreshControl,
  StyleSheet,
  View,
} from "react-native";

import EmptyContentView from "@/Components/EmptyState/EmptyContentView";
import ScreenLoadingIcon from "@/Components/Icons/Loading/ScreenLoadingIcon";
import { type UserLikableImageMedia } from "@/schemas/user/image";
import { Spacings } from "@/styling/spacings";

/* This can be extended to other action items */

type ImageGridItem = UserLikableImageMedia | null;

type ImageGridProps = {
  images: ImageGridItem[] | null;
  isLoading: boolean;
  isLoadingMore: boolean;
  onRefresh: () => void;
  onLoadMore: () => Promise<void>;
  renderImage: ListRenderItem<UserLikableImageMedia | null>;
};

function ImageGrid({
  images,
  isLoading,
  isLoadingMore,
  onRefresh,
  onLoadMore,
  renderImage,
}: ImageGridProps): React.JSX.Element {
  return (
    <View style={styles.container}>
      {isLoading ? (
        <ScreenLoadingIcon />
      ) : (
        <FlatList
          contentContainerStyle={styles.flatListContent}
          showsVerticalScrollIndicator={false}
          data={images}
          renderItem={renderImage}
          keyExtractor={(item, index) => item?.image.id || index.toString()}
          numColumns={2}
          onEndReached={onLoadMore}
          columnWrapperStyle={styles.columnWrapper}
          refreshControl={
            <RefreshControl refreshing={isLoading} onRefresh={onRefresh} />
          }
          ListEmptyComponent={
            // TODO: check profile username == viewer, if so, show upload button
            <EmptyContentView
              emptyTitle="No photos available"
              primaryMaterialCommunityIconName="image-off-outline"
            />
          }
          ListFooterComponent={
            isLoadingMore ? <ActivityIndicator size={"large"} /> : null
          }
        />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: Spacings.s1,
  },
  columnWrapper: {
    justifyContent: "space-between",
    marginBottom: Spacings.s1,
  },
  flatListContent: {
    flexGrow: 1,
  },
});

export default ImageGrid;
